module.exports = __webpack_public_path__ + "img/child-4.5b8c80e.jpg?v=1753096006164";